import { useState, useEffect } from "react"
import api from '../../utils/api'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import useMyPermission from '../../hooks/useMyPermission'

import FormFiscalConfig from './Form/FormFiscalConfig'
import Button from '../../shared/components/Button/Button'
import './FiscalConfig.css'

const FORM_ID = 'fiscalConfigForm'

function FiscalConfig() {
    const [token] = useState(localStorage.getItem('token') || '')
    const [config, setConfig] = useState({})
    const [load, setLoad] = useState(false)
    const { setFlashMessage } = useFlashMessage()

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionView = checkPermission(myPermission, "fiscal_view")
    const myPermissionEdit = checkPermission(myPermission, "fiscal_edit")

    useEffect(() => {
        api.get('/fiscal/config', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            setConfig(response.data.fiscalConfig)
            setMyPermission(response.data.permission)
            setLoad(true)
        })
    }, [token])

    async function submit(data) {
        let msgType = 'success'
        const response = await api.patch('/fiscal/config', data, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((res) => {
            return res.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(response.message, msgType)
    }

    if (!load) {
        return <div className="pg-loading">Carregando perfil da empresa...</div>
    }

    if (!myPermissionView) {
        return (
            <div className="pg-empty">
                <p className="pg-empty-title">Sem permissão para visualizar o perfil da empresa</p>
            </div>
        )
    }

    return (
        <section className="pg-page">
            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Perfil da Empresa (Emitente)</p>
                        <span className="pg-title-accent" />
                    </div>
                    {myPermissionEdit && (
                        <div className="pg-header-row">
                            <div className="pg-header-actions">
                                <Button variant="save" type="submit" form={FORM_ID}>Salvar</Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="fc-wrap">
                <FormFiscalConfig
                    configData={config}
                    handleSubmit={submit}
                    formId={FORM_ID}
                />
            </div>
        </section>
    )
}

export default FiscalConfig
